import React, { useContext } from "react";
import styles from "./adminnavigator.module.css";
import PersonIcon from "@mui/icons-material/Person";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import StoreIcon from "@mui/icons-material/Store";
import { useTranslation } from "react-i18next";
import { NavigationContext } from "../../context/Admin_context";

const AdminNavigator = React.memo(() => {
  const { t } = useTranslation();
  const { open, setOpen } = useContext(NavigationContext);

  const handleClick = (type) => {
    setOpen({
      isManageUsers: type === "isManageUsers",
      isManageProduct: type === "isManageProduct",
      isManageSeller: type === "isManageSeller",
      isManageCategories: type === "isManageCategories"
    });
  };

  return (
    <div className={styles.userNavigator}>
      <div className={styles.userDisplay}>
        <div className={styles.userName}>{t("admin_page")}</div>
      </div>
      <div className={styles.menu}>
        <div className={styles.menuItemBox}>
          <div
            className={open.isManageUsers ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isManageUsers")}
          >
            <PersonIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("manage_users")}</span>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={open.isManageSeller ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isManageSeller")}
          >
            <StoreIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("manage_sellers")}</span>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={open.isManageProduct ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isManageProduct")}
          >
            <ShoppingBasketIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("manage_products")}</span>
          </div>
        </div>
        <div className={styles.menuItemBox}>
          <div
            className={open.isManageCategories ? styles.menuItemActive : styles.menuItem}
            onClick={() => handleClick("isManageCategories")}
          >
            <ShoppingBasketIcon sx={{ fontSize: 30, color: "black" }} />
            <span>{t("manage_category")}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export {AdminNavigator};
